<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-2">
      <div class="col-12">
        <div class="card h-100">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="row">
                  <div
                    v-if="finishHandling || helpdata.status == 4"
                    class="complete-watermark"
                  >
                    {{ $t("help.completed") }}
                  </div>
                  <div class="col-xs-12 col-md-8">
                    <h5 class="mt-1">
                      {{ $t("help.id-support") }} : {{ helpdata.id_support }}
                    </h5>
                  </div>
                  <div class="col-md-4" v-if="helpdata != 0">
                    <div v-if="finishHandling && helpdata.status == 2">
                      <div class="text-right">
                        <b-button
                          size="sm"
                          variant="success"
                          class="mr-1"
                          @click="openFinishModal"
                          ><i class="fa fa-check-circle"></i>
                          {{ $t("help.close-support") }}
                        </b-button>
                      </div>
                    </div>
                    <div v-if="!finishHandling && helpdata.status != 4">
                      <div class="text-right" v-if="helpdata.status != 3">
                        <b-button
                          size="sm"
                          variant="danger"
                          class="mr-1"
                          @click="openRejectModal"
                          ><i class="fa fa-times"></i>
                          {{ $t("button.rejected") }}
                        </b-button>
                        <b-button
                          v-if="helpdata.status == 0"
                          size="sm"
                          variant="success"
                          class="mr-1"
                          @click="acceptTicket"
                        >
                          <i class="fa fa-check" v-if="!loading.action"></i>
                          <b-spinner
                            variant="light"
                            small
                            v-if="loading.action"
                          ></b-spinner>
                          {{ $t("button.accept") }}
                        </b-button>
                        <b-button
                          v-if="helpdata.category == 12"
                          size="sm"
                          variant="success"
                          class="mr-1"
                          @click="openFinishModal"
                          ><i class="fa fa-check-circle"></i>
                          {{ $t("help.close-support") }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-2" />
              </div>

              <b-modal
                id="modal-finish"
                centered
                bordered
                title="Close Support"
                title-class="font-18"
                :ok-title="'Finish'"
                :cancel-title="$t('button.cancel.text')"
              >
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      {{ $t("help.this-action-means") }}
                    </p>
                    <table
                      class="table"
                      v-if="helpdata.handling_advice != null"
                    >
                      <tr
                        v-for="(hd, index) in JSON.parse(
                          helpdata.handling_advice
                        )"
                        :key="index"
                      >
                        <td width="150px">{{ hd.advice }}</td>
                        <td>
                          <span class="text-success" v-if="hd.status == 0">
                            <i class="fa fa-clock"></i>
                          </span>
                          <span class="text-success" v-if="hd.status == 1">
                            <i class="fa fa-exclamation-circle"></i>
                          </span>
                          <span class="text-success" v-if="hd.status == 2">
                            <i class="fa fa-check-circle"></i>
                          </span>
                        </td>
                      </tr>
                    </table>

                    <p class="">
                      <strong>
                        {{ $t("help.this-action-may") }}
                      </strong>
                    </p>
                  </div>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-button
                    size="md"
                    variant="outline-secondary"
                    @click="cancel()"
                  >
                    {{ $t("button.cancel.text") }}
                  </b-button>
                  <b-button size="md" variant="success" @click="finishTicket">
                    <b-spinner
                      variant="light"
                      small
                      v-if="loading.action"
                    ></b-spinner>
                    {{ $t("help.finish") }}
                  </b-button>
                </template>
              </b-modal>

              <b-modal
                id="modal-reject"
                centered
                bordered
                title="Rejection Form"
                title-class="font-18"
                :ok-title="'Reject'"
                :cancel-title="$t('button.cancel.text')"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="reject-option">{{
                        $t("help.rejected-type")
                      }}</label>
                      <select
                        class="form-control"
                        v-model="form.support.reject_option"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.support.reject_option.$error,
                        }"
                      >
                        <option value="">{{ $t("help.select-reason") }}</option>
                        <option value="Request Data Not Match">
                          {{ $t("help.request-data-not-match") }}
                        </option>
                        <option value="Incomplete Request Data">
                          {{ $t("help.incomplate-request-data") }}
                        </option>
                        <option value="Verification Image Failed">
                          {{ $t("help.verification-image-failed") }}
                        </option>
                        <option value="Other">{{ $t("help.other") }}</option>
                      </select>
                      <div
                        v-if="submitted && $v.form.support.reject_option.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.support.reject_option.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="reject-reason">{{
                        $t("help.description")
                      }}</label>
                      <textarea
                        class="form-control"
                        cols="30"
                        rows="10"
                        placeholder="Reason ..."
                        v-model="form.support.reject_reason"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.support.reject_reason.$error,
                        }"
                      >
                      </textarea>
                      <div
                        v-if="submitted && $v.form.support.reject_reason.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.support.reject_reason.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-button
                    size="md"
                    variant="outline-secondary"
                    @click="cancel()"
                  >
                    {{ $t("button.cancel.text") }}
                  </b-button>
                  <b-button size="md" variant="success" @click="rejectTicket">
                    <b-spinner
                      variant="light"
                      small
                      v-if="loading.action"
                    ></b-spinner>
                    {{ $t("help.reject") }}
                  </b-button>
                </template>
              </b-modal>

              <div class="col-xs-12 col-sm-6 mb-1">
                <h4 class="mb-4">{{ $t("help.applicaton-data") }}</h4>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <tr>
                      <td width="30%">{{ $t("user-management.name") }}</td>
                      <td width="70%">
                        {{
                          helpdata.user.profile != null
                            ? helpdata.user.profile.name
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">NRP</td>
                      <td width="70%">{{ helpdata.nonrp }}</td>
                    </tr>
                    <tr>
                      <td width="30%">{{ $t("help.current-number") }}</td>
                      <td width="70%">
                        {{
                          helpdata.user != null ? helpdata.user.address : "-"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">
                        {{ $t("user-management.lastonline") }}
                      </td>
                      <td width="70%">
                        {{
                          helpdata.user != null
                            ? formatDateTimes(helpdata.user.lastonline)
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td width="30%">
                        {{ $t("user-management.ip-address") }}
                      </td>
                      <td width="70%">
                        {{
                          helpdata.user != null
                            ? ipconvert(helpdata.user.ipaddr, false)
                            : "-"
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div class="col-xs-12 col-sm-6 mb-1">
                <h4 class="mb-4">{{ $t("help.request-data") }}</h4>
                <table class="table table-bordered">
                  <tr>
                    <td width="30%">{{ $t("help.category") }}</td>
                    <td width="70%">{{ setCategory(helpdata.category) }}</td>
                  </tr>
                  <tr>
                    <td width="30%">{{ $t("help.request-at") }}</td>
                    <td width="70%">{{ formatDate(helpdata.created_at) }}</td>
                  </tr>
                  <tr>
                    <td width="30%">{{ $t("help.note") }}</td>
                    <td width="70%">{{ helpdata.note }}</td>
                  </tr>
                  <tr>
                    <td width="30%">Status</td>
                    <td width="70%">
                      <span
                        v-if="helpdata.status == 0"
                        class="badge badge-secondary badge-pill p-2"
                        >{{ $t("help.await") }}</span
                      >
                      <span
                        v-if="helpdata.status == 1"
                        class="badge badge-success badge-pill p-2"
                        >{{ $t("help.accepted") }}</span
                      >
                      <span
                        v-if="helpdata.status == 2"
                        class="badge badge-warning badge-pill p-2"
                        >{{ $t("help.on-progress") }}</span
                      >
                      <span
                        v-if="helpdata.status == 3"
                        class="badge badge-danger badge-pill p-2"
                        >{{ $t("help.rejected") }}</span
                      >
                      <span
                        v-if="helpdata.status == 4"
                        class="badge badge-primary badge-pill p-2"
                      >
                        {{ $t("help.completed") }}</span
                      >
                    </td>
                  </tr>
                  <tr v-if="helpdata.category != 12">
                    <td width="30%">{{ $t("help.verification_image") }}</td>
                    <td width="70%">
                      <b-button
                        variant="success"
                        class="btn btn-sm"
                        @click="openShowModal"
                        >Show</b-button
                      >
                    </td>
                  </tr>
                </table>
              </div>

              <div class="col-12" v-if="helpdata.status == 3">
                <div class="row">
                  <div class="col-6"></div>
                  <div class="col-6 mt-3">
                    <h4>{{ $t("help.rejected-reason") }}</h4>
                    <table class="table table-bordered">
                      <tr>
                        <td>{{ $t("help.type") }}</td>
                        <td>{{ JSON.parse(helpdata.rejected_reason).type }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t("help.description") }}</td>
                        <td>{{ JSON.parse(helpdata.rejected_reason).desc }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-show"
      size="xl"
      centered
      bordered
      hide-footer
      title="Verification Image"
      title-class="font-18"
    >
      <div class="row">
        <div class="col-md-12">
          <img
            :src="urlImage + helpdata.verification_image"
            alt="Verification Image"
            srcset=""
            class="w-100"
          />
        </div>
      </div>
    </b-modal>

    <div class="row mb-4" v-if="helpdata.status != 0 && helpdata.status != 3">
      <div class="col-12" v-if="helpdata.category == 11">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-4">{{ $t("help.handling-advice") }}</h4>
            <div class="table-responsive mb-0">
              <table
                class="table table-nowrap table-centered"
                v-if="helpdata.handling_advice"
              >
                <tbody>
                  <tr
                    v-for="(handling, index) in JSON.parse(
                      helpdata.handling_advice
                    )"
                    :key="index"
                    :class="
                      handling.status == 0 || handling.status == 2
                        ? 'bg-light text-muted'
                        : ''
                    "
                  >
                    <td style="width: 60px">
                      <span v-if="handling.status == 1"
                        ><i class="bx bx-circle bx-xs"></i
                      ></span>
                      <span v-if="handling.status == 2"
                        ><i class="text-success bx bx-check-circle bx-xs"></i
                      ></span>
                      <span v-if="handling.status == 0"
                        ><i class="bx bx-time bx-xs"></i
                      ></span>
                    </td>
                    <td>
                      <h5 class="text-truncate font-size-14 m-0">
                        <a
                          href="javascript: void(0);"
                          class="text-dark"
                          :class="
                            handling.status == 0 || handling.status == 2
                              ? 'text-muted'
                              : ''
                          "
                          >{{ handling.advice }}</a
                        >
                      </h5>
                    </td>
                    <td>
                      <p>
                        {{ handling.description }}
                      </p>
                    </td>
                    <td>
                      <div class="text-center">
                        <b-button
                          v-if="handling.status == 2"
                          :class="handling.status == 2 ? 'disabled' : ''"
                          size="sm"
                          variant="outline-success"
                          class="mr-1"
                        >
                          {{ $t("help.done") }}
                        </b-button>
                        <b-button
                          v-if="handling.status != 2"
                          :class="handling.status == 0 ? 'disabled' : ''"
                          size="sm"
                          variant="outline-secondary"
                          class="mr-1"
                          @click="
                            handling.status == 0
                              ? ''
                              : openCommitModal(handling.id_advice)
                          "
                        >
                          {{ $t("help.commit") }}
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="helpdata.category == 12">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-4">Attachment Image</h4>
            <div class="row">
              <div
                class="col-4"
                v-for="(val, idx) in JSON.parse(helpdata.support_image)"
                :key="idx"
              >
                <img
                  v-if="val"
                  :src="urlSupportImage + val"
                  class="border border-secondary rounded bg-light hoverable support-image"
                  alt=""
                  srcset=""
                  @click="openSupportImageModal(idx)"
                />
                <img
                  v-else
                  :src="urlSupportImage + 'default-image.png'"
                  class="border border-secondary rounded w-100 bg-light support-image"
                  alt=""
                  srcset=""
                />
                <div class="text-center mt-2">
                  <span class="font-weight-bold">Image {{ idx + 1 }}</span>
                </div>
                <b-modal
                  :id="'modal-support-image' + idx"
                  size="xl"
                  centered
                  bordered
                  hide-footer
                  :title="'Attachment Image ' + (idx + 1)"
                  title-class="font-18"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <img
                        :src="urlSupportImage + val"
                        alt="Support Image"
                        srcset=""
                        class="w-100"
                      />
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-reset"
      centered
      bordered
      :title="$t('help.reset-number')"
      title-class="font-18"
      :ok-title="'Execute'"
      :cancel-title="$t('button.cancel.text')"
    >
      <div class="row">
        <div class="col-md-12">
          <p>
            {{ $t("help.this.action") }}
            {{ $t("help.this-action-will-reset") }}
          </p>
          <table class="table">
            <tr>
              <td width="150px">{{ $t("help.old-number") }}</td>
              <td>:</td>
              <td>{{ helpdata.address }}</td>
            </tr>
            <tr>
              <td>{{ $t("help.new-number") }}</td>
              <td>:</td>
              <td>{{ helpdata.new_address }}</td>
            </tr>
          </table>

          <p class="">
            <strong> {{ $t("help.this-action-may") }} </strong>
          </p>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="md" variant="outline-secondary" @click="cancel()">
          {{ $t("button.cancel.text") }}
        </b-button>
        <b-button size="md" variant="success" @click="handlingReset">
          <b-spinner variant="light" small v-if="loading.handling"></b-spinner>
          {{ $t("help.execute") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-deactive"
      centered
      bordered
      title="Deactive Number"
      title-class="font-18"
      :ok-title="'Execute'"
      :cancel-title="$t('button.cancel.text')"
    >
      <div class="row">
        <div class="col-md-12">
          <p>
            {{ $t("help.this-action") }}
            {{ $t("help.this-action-will-deactivate") }}
          </p>
          <table class="table">
            <tr>
              <td width="150px">{{ $t("help.deactive-number") }}</td>
              <td>:</td>
              <td>{{ helpdata.address }}</td>
            </tr>
          </table>

          <p class="">
            <strong> {{ $t("help.this-action") }} </strong>
          </p>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="md" variant="outline-secondary" @click="cancel()">
          {{ $t("button.cancel.text") }}
        </b-button>
        <b-button size="md" variant="success" @click="handlingDeactive">
          <b-spinner variant="light" small v-if="loading.handling"></b-spinner>
          {{ $t("help.execute") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-force-exit"
      centered
      bordered
      title="Force Exit Device"
      title-class="font-18"
      :ok-title="'Execute'"
      :cancel-title="$t('button.cancel.text')"
    >
      <div class="row">
        <div class="col-md-12">
          <p>
            {{ $t("help.this-action") }}
            {{ $t("help.this-action-will-force") }}
          </p>
          <table class="table">
            <tr>
              <td width="150px">{{ $t("help.device-name") }}</td>
              <td>:</td>
              <td>Samsung S20</td>
            </tr>
          </table>

          <p class="">
            <strong>{{ $t("help.this-action-may") }} </strong>
          </p>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="md" variant="outline-secondary" @click="cancel()">
          {{ $t("button.cancel.text") }}
        </b-button>
        <b-button size="md" variant="success" @click="handlingForceExit">
          <b-spinner variant="light" small v-if="loading.handling"></b-spinner>
          {{ $t("help.execute") }}
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import SupportService from "@/helpers/support.service";
import IpConvert from "@/helpers/ipconvert";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { DatePicker, Layout, PageHeader },
  data() {
    return {
      title: this.$t("help.support-detail"),
      id: this.$route.params.id,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: this.$t("help.support"),
          href: "/support",
        },
        {
          text: this.$t("help.support-detail"),
          active: true,
        },
      ],
      helpdata: [],
      urlImage: process.env.VUE_APP_BASE_URL + "verification-image/",
      urlSupportImage: process.env.VUE_APP_BASE_URL + "support-image/",
      form: {
        support: {
          reject_reason: "",
          reject_option: "",
        },
      },
      submitted: false,
      loading: {
        action: false,
        handling: false,
      },
      finishHandling: false,
    };
  },
  validations: {
    form: {
      support: {
        reject_reason: { required },
        reject_option: { required },
      },
    },
  },
  mounted() {
    this.getSupport();
  },
  methods: {
    getSupport() {
      SupportService.DetailHelpSupport(this.id)
        .then((response) => {
          this.helpdata = [];
          this.helpdata = response.data.data;
          this.checkHandlingStatus();
        })
        .catch((err) => {});
    },

    acceptTicket() {
      const data = {
        status_support: 1,
      };
      this.loading.action = true;
      SupportService.updateSupport(this.id, data)
        .then((response) => {
          this.getSupport();
          this.loading.action = false;
        })
        .catch((err) => {
          this.loading.action = false;
        });
    },

    rejectTicket(e) {
      this.submitted = true;
      this.$v.form.support.$touch();
      if (
        this.form.support.reject_reason == "" ||
        this.form.support.reject_option == ""
      ) {
        e.preventDefault();
      } else {
        const data = {
          status_support: 3,
          rejected_reason: {
            type: this.form.support.reject_option,
            desc: this.form.support.reject_reason,
          },
        };
        this.loading.action = true;
        SupportService.updateSupport(this.id, data)
          .then((response) => {
            this.loading.action = false;
            this.$bvModal.hide("modal-reject");
            this.getSupport();
          })
          .catch((err) => {
            this.loading.action = false;
            this.$bvModal.hide("modal-reject");
          });
      }
    },

    finishTicket() {
      const data = {
        status_support: 4,
      };
      this.loading.action = true;
      SupportService.updateSupport(this.id, data)
        .then((response) => {
          this.loading.action = false;
          this.$bvModal.hide("modal-finish");
          this.getSupport();
        })
        .catch((err) => {
          this.loading.action = false;
          this.$bvModal.hide("modal-finish");
        });
    },

    handlingReset() {
      const data = {
        id_support: this.id,
      };
      this.loading.handling = true;
      SupportService.resetNumber(data)
        .then((response) => {
          this.loading.handling = false;
          this.$bvModal.hide("modal-reset");
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.getSupport();
        })
        .catch((err) => {
          this.loading.handling = false;
          this.$bvModal.hide("modal-reset");
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: err.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    handlingDeactive() {
      const data = {
        id_support: this.id,
      };
      this.loading.handling = true;
      SupportService.deactiveNumber(data)
        .then((response) => {
          this.loading.handling = false;
          this.$bvModal.hide("modal-deactive");
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.getSupport();
        })
        .catch((err) => {
          this.loading.handling = false;
          this.$bvModal.hide("modal-deactive");
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: err.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    handlingForceExit() {
      const data = {
        id_support: this.id,
      };
      this.loading.handling = true;
      SupportService.forceExit(data)
        .then((response) => {
          this.loading.handling = false;
          this.$bvModal.hide("modal-force-exit");
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.getSupport();
        })
        .catch((err) => {
          this.loading.handling = false;
          this.$bvModal.hide("modal-force-exit");
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: err.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    checkHandlingStatus() {
      if (this.helpdata != 0) {
        const hd = JSON.parse(this.helpdata.handling_advice);
        let unfinish = hd.some((el) => el.status == 1 || el.status == 0);
        if (!unfinish) {
          this.finishHandling = true;
        }
      }
    },

    openSupportImageModal(idx) {
      console.log("idasd ", idx);
      this.$bvModal.show("modal-support-image" + idx);
    },

    openFinishModal() {
      this.$bvModal.show("modal-finish");
    },

    openShowModal() {
      this.$bvModal.show("modal-show");
    },

    openRejectModal() {
      this.$bvModal.show("modal-reject");
    },

    openCommitModal(id) {
      if (id == "AD1") {
        this.$bvModal.show("modal-reset");
      }
      if (id == "AD2") {
        this.$bvModal.show("modal-deactive");
      }
      if (id == "AD3") {
        this.$bvModal.show("modal-force-exit");
      }
    },

    setCategory(id) {
      let cat = "-";
      switch (id) {
        case "11":
          cat = "Lost Device";
          break;
        case "12":
          cat = "Feedback & Support";
          break;

        default:
          cat = "-";
          break;
      }

      return cat;
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, HH:mm");
    },

    formatDateTimes(value) {
      var unixTime = value;
      var momentDate = moment.unix(unixTime),
        momentDay = momentDate.format("DD"),
        momentMonth = momentDate.format("MM"),
        momentYear = momentDate.format("YYYY"),
        momentHours = momentDate.format("HH"),
        momentMinutes = momentDate.format("mm"),
        momentSeconds = momentDate.format("ss");

      var t =
        '"' +
        momentYear +
        "-" +
        momentMonth +
        "-" +
        momentDay +
        " " +
        momentHours +
        ":" +
        momentMinutes +
        '"';
      var cdt = moment(t, "YYYY-MM-DD HH:mm");
      let a = this.formatDate(cdt);
      return a;
    },

    ipconvert(value, toDec) {
      if (toDec) {
        return IpConvert.ip2dec(value);
      } else {
        return IpConvert.dec2ip(value);
      }
    },
  },
};
</script>
<style>
.complete-watermark {
  font-family: "Big Shoulders Stencil Text", cursive;
  position: absolute;
  right: 10px;
  top: -18px;
  color: #059669;
  opacity: 0.6;
  font-size: 35px;
  font-weight: bolder;
  border: 3px solid #059669;
  padding: 0px 15px;
  border-radius: 10px;
}
.support-image {
  height: 500px;
  width: 500px;
  object-fit: cover;
}
.hoverable:hover {
  cursor: pointer;
}
</style>